import { explanationIds } from "../../common/authentication/models/user";

export class ExplanationService {
    showExplanation: (id: explanationIds) => void;
    closeExplanation: () => void;

    constructor(showExplanation, closeExplanation){
        this.showExplanation = showExplanation;
        this.closeExplanation = closeExplanation;
    }
}
